// LEGACY UI: replace with a toast primitive (frontend-ui has none yet: add shadcn Sonner) from @workspace/frontend-ui.
// Don't import this in new code; legacy-ui.json tracks the remaining importers
// and only shrinks (scripts/legacy-ui-check.mjs).

import GenericCheckRounded from "@casino/external/icons/GenericCheckRounded";
import Snackbar from "@casino/legacyUi/Snackbar";
import type { SetStateAction } from "react";

type Props = {
  isOpen: boolean;
  onOpenChange:
    | ((value: SetStateAction<boolean>) => void)
    | ((value: boolean) => void);
  message?: string;
  variant: ToastProps["variant"];
};

const Toast: FC<Props> = ({ isOpen, onOpenChange, message }) => (
  // TODO: add variants
  <div className="absolute">
    <Snackbar
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      position="bottom-left"
      className="min-w-44 rounded-xl bg-foreground"
      autoClose={3000}
    >
      <Snackbar.Icon>
        <GenericCheckRounded
          className="text-background"
          fill="var(--positive)"
        />
      </Snackbar.Icon>
      <Snackbar.Message className="text-background">{message}</Snackbar.Message>
    </Snackbar>
  </div>
);

export default Toast;
